import { AppBar, Toolbar, Typography, Avatar } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import logo from "../../assets/logo.png";
import "./style.css";
import UserService, { User } from "../../services/UserService";
import { useEffect, useState } from "react";
import { red } from "@mui/material/colors";


export function HeaderComponent(){
  const imageUrl =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmqK2y57boN58dRh3wxpcF6OdjZkzoiopYxK5oQRD_pQ&s";
  
  const [user, setUser] = useState<User>()

  useEffect(() => {
    setUser(UserService.getUser())
  }, [])

  return (
    <AppBar className="component-header">
      <Toolbar className="header-component">
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1 }}
          className="div-typography"
        >
          <img src={logo} alt="VIVA MÓVEIS Logo" className="logo" />
        </Typography>
        {imageUrl ? (
          <>
            <p className="name-of-user">{user?.name ?? "User"}</p>
            <Avatar sx={{ color: red[500] }} className="list-item-avatar">
              <h4 className="letter-name-user">{user?.name?.charAt(0)}</h4>
            </Avatar>
          </>
        ) : (
          <AccountCircle />
        )}
      </Toolbar>
    </AppBar>
  );
}

